'use strict';

import { toast } from 'react-toastify';
import { getItem } from './storage';

const __showToast = ({ type = 'success', message }) => {
  toast[type](message);
};

const __hasRole = (roles = [], role_id = 0) => {
  const userCurrent = getItem('USER_CURRENT');
  role_id = !role_id ? userCurrent.role_id : role_id;

  // console.log('role_id', role_id);
  // console.log('roles', roles);

  return roles.includes(role_id);
};

export { __showToast, __hasRole };
